import { Stack } from "@mantine/core"

interface PageLayoutProps {
  /** Full-width header (typically PageHeader) */
  header?: React.ReactNode
  /** Sticky footer (typically StickyFooter) — placed outside the padded area */
  footer?: React.ReactNode
  /** Body content placed inside a padded container */
  children: React.ReactNode
}

export default function PageLayout({ header, footer, children }: PageLayoutProps) {
  return (
    <Stack gap={0} style={{ minHeight: "100%" }}>
      {header && (
        <div style={{ position: "sticky", top: 0, zIndex: 10 }}>
          {header}
        </div>
      )}
      <Stack p="md" style={{ flex: 1 }}>
        {children}
      </Stack>
      {footer}
    </Stack>
  )
}
